export default __webpack_public_path__ + "97ba28c1758b319e218aa401d3e29e10.png";